'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class ArianneComponent {
  constructor(Auth, $scope) {
    'ngInject';
    var vm = this
    vm.test = 'Test !'
  }

}

export default angular.module('directives.arianne', [])
  .component('arianne', {
    template: require('./arianne.html'),
    restrict: 'E',
    bindings: {
        app: '=',
    },
    controller: ArianneComponent,
    controllerAs: 'vm'
  }).name


/*export default angular.module('directives.arianne', [])
  .component('arianne', {
    template: require('./arianne.html'),
    controller: ArianneComponent,
    controllerAs: 'vm',
    bindings: {
        fil: '='
    }
  })
  .name;*/



// WEBPACK FOOTER //
// ./client/components/arianne/arianne.component.js